import { COMPANY_ALIAS } from '../../../constants/global';
import { COMMON_ATTRIBUTES, COMMON_QUESTIONS, COMMON_VIEW_LABEL } from '../constants';

export const IDB_ATTRIBUTES = {
  ...COMMON_ATTRIBUTES,
  TREATMENT_LOCATION: 'location_id',
  INTRAORAL_SCAN_DATE: 'intraoral_scan_date',
  INITIAL_CASE_SETUP_ASSIGNMENT: 'submission_completed_by',
  ALLOWED_DIBS_OPTIONS: 'allowed_dibs_options',
  SCAN_SUBMISSION_METHOD: 'scan_submission_type',
  SCANNER: 'scanner_type',
  CUSTOM_SCANNER_NAME: 'custom_scanner_type_name',
  STL_FILES: 'stl_files',
  INTRAORAL_PHOTOS: 'rx_intraoral_photos',
  ARCH_TYPE: 'jaws_id',
  RUSH_CASE_ENABLED: 'rush_case_enabled',
  RUSH_CASE: 'rush_case',
  RUSH_CASE_AUTHORIZED_BY_NAME: 'rush_case_authorized_by',
  EXPORT_TYPE: 'export_type',
  PRINT_ASSIGNMENT: 'print_assignment',
  TRAY_DESIGN_ASSIGNMENT: 'tray_design_assignment',
  INSERT_BRACKETS_ASSIGNMENT: 'insert_brackets_assignment',
  ROOT_INTEGRATION: 'root_integration',
  ROOT_INTEGRATION_TYPE: 'root_integration_type',
  BRACKET_LIBRARIES: 'bracket_libraries',
  CUSTOM_BRACKET_SET_ID: 'custom_bracket_set_id',
  BONDING_DATE: 'bonding_date',
  ARCH_WIRES: 'arch_wires',
  DICOM_FILES: 'dicom_files',
  ARCH_WIRE_OPTIONS: 'arch_wire_options',
  CUSTOM_SETUP_ENABLED: 'custom_setup_enabled',
  TEETH: 'teeth',
  SAVED_FOR_LATER: 'saved_for_later',
  // removed
  CUSTOM_SETUP: 'custom_setup'
};

export const STATEMENTS = {
  [IDB_ATTRIBUTES.INITIAL_CASE_SETUP_ASSIGNMENT]: 'Your Initial case setup will be completed by:',
  [IDB_ATTRIBUTES.SCAN_SUBMISSION_METHOD]: 'Upload Intraoral Scans.',
  [IDB_ATTRIBUTES.PRINT_ASSIGNMENT]: 'Print by:',
  [IDB_ATTRIBUTES.INSERT_BRACKETS_ASSIGNMENT]: 'Insert brackets by:',
  [IDB_ATTRIBUTES.EXPORT_TYPE]: 'Export:'
};

export const QUESTIONS = {
  ...COMMON_QUESTIONS,
  [IDB_ATTRIBUTES.TREATMENT_LOCATION]: 'Which Treatment Location?',
  [IDB_ATTRIBUTES.INTRAORAL_SCAN_DATE]: 'Intraoral Scan Date',
  [IDB_ATTRIBUTES.INITIAL_CASE_SETUP_ASSIGNMENT]:
    'Who would you like to complete the initial case setup?',
  [IDB_ATTRIBUTES.RUSH_CASE_ENABLED]: 'Is rush case enabled?',
  [IDB_ATTRIBUTES.RUSH_CASE]: 'Is this a Rush Case?',
  [IDB_ATTRIBUTES.RUSH_CASE_AUTHORIZED_BY_NAME]: 'Name of the person authorizing the rush.',
  [IDB_ATTRIBUTES.SCAN_SUBMISSION_METHOD]: 'How will you be submitting your scans?',
  [IDB_ATTRIBUTES.SCANNER]: 'What type of scanner do you have?',
  [IDB_ATTRIBUTES.CUSTOM_SCANNER_NAME]: 'What type of scanner do you have?',
  [IDB_ATTRIBUTES.STL_FILES]: 'Upload intraoral STL files.',
  [IDB_ATTRIBUTES.INTRAORAL_PHOTOS]: 'Upload intraoral STL files.',
  [IDB_ATTRIBUTES.ARCH_TYPE]: 'Which arches will you be bonding?',
  [IDB_ATTRIBUTES.EXPORT_TYPE]: 'What do you want to export?',
  [IDB_ATTRIBUTES.PRINT_ASSIGNMENT]: 'Who is printing?',
  [IDB_ATTRIBUTES.TRAY_DESIGN_ASSIGNMENT]: 'Who will digitally design the trays?',
  [IDB_ATTRIBUTES.INSERT_BRACKETS_ASSIGNMENT]: 'Who is inserting brackets?',
  [IDB_ATTRIBUTES.ROOT_INTEGRATION_TYPE]: 'Include Root & Bone integration?',
  [IDB_ATTRIBUTES.BRACKET_LIBRARIES]:
    'Choose the brackets for this case (these can easily be changed later) ',
  [IDB_ATTRIBUTES.BONDING_DATE]: 'Is bonding date enabled?',
  [IDB_ATTRIBUTES.ARCH_WIRES]: '(Optional) Choose your finishing archwire',
  [IDB_ATTRIBUTES.ALLOWED_DIBS_OPTIONS]: 'Which DIBS options are supported?',
  [IDB_ATTRIBUTES.ARCH_WIRE_OPTIONS]: 'Which finishing archwires (built-in) are supported?',
  [IDB_ATTRIBUTES.CUSTOM_SETUP_ENABLED]: 'Is custom setups enabled?',
  [IDB_ATTRIBUTES.CUSTOM_SETUP]:
    'Would you like a better, custom setup based on your doctor preferences?',
  [IDB_ATTRIBUTES.TEETH]: 'Teeth'
};

export const VIEW_LABEL = {
  ...COMMON_VIEW_LABEL,
  [IDB_ATTRIBUTES.BRACKET_LIBRARIES]: 'Choose the brackets for this case',
  [IDB_ATTRIBUTES.BONDING_DATE]: 'When would you like to receive this case?',
  [IDB_ATTRIBUTES.ARCH_WIRES]: 'Choose your finishing archwire'
};

export const HELPER_TEXT = {
  [IDB_ATTRIBUTES.RUSH_CASE]:
    'This case will be ready for doctor approval within one hour when submitted during regular business hours: Mon. - Fri. 8am - 4pm (MST).'
};

export const SUB_LABEL = {
  [IDB_ATTRIBUTES.RUSH_CASE]:
    'Note: expedited shipping is a separate option selected by the doctor when approving this case.'
};

const createOptions = options => {
  return Object.entries(options).map(([value, label]) => ({
    value,
    label
  }));
};

export const ASSIGNMENTS = {
  ORTHOSELECT: 1,
  IN_OFFICE: 2,
  THIRD_PARTY: 3
};

export const DIBS_OPTIONS = {
  DIBS_DESKTOP: 1,
  DIBS_ONLINE: 4
};

export const SCAN_SUBMISSION_METHODS = {
  UPLOAD: 1,
  SCANNER: 2
};

export const ARCHES = {
  MAXILLARY: 1,
  MANDIBULAR: 2,
  BOTH: 3
};

export const EXPORTS = {
  TRAYS: 1,
  GUIDES: 2,
  BRACKETS: 3
};

export const SCANNERS = {
  ITERO: 1,
  THREE_SHAPE: 2,
  THREE_M: 3,
  CARESTREAM: 4,
  CEREC: 5,
  MEDIT: 6,
  ALLIEDSTAR: 8,
  OTHER: 7
};

export const ROOT_INTEGRATION_TYPES = {
  NONE: 0,
  DICOM: 1,
  AI: 2
};

export const ROOT_INTEGRATION_TYPE_LABELS = {
  [ROOT_INTEGRATION_TYPES.NONE]: 'No',
  [ROOT_INTEGRATION_TYPES.DICOM]: 'Yes - Upload DICOM | Most Accurate',
  [ROOT_INTEGRATION_TYPES.AI]: 'Yes - AI-Generated | No DICOM Required'
};

export const ASSIGNMENT_LABELS = {
  [ASSIGNMENTS.ORTHOSELECT]: COMPANY_ALIAS,
  [ASSIGNMENTS.IN_OFFICE]: 'In-office',
  [ASSIGNMENTS.THIRD_PARTY]: '3PP'
};

export const TRAY_DESIGN_ASSIGNMENT_LABELS = {
  [ASSIGNMENTS.ORTHOSELECT]: COMPANY_ALIAS,
  [ASSIGNMENTS.IN_OFFICE]: 'In-office'
};

export const ASSIGNMENT_SHORT_LABELS = {
  [ASSIGNMENTS.ORTHOSELECT]: 'O',
  [ASSIGNMENTS.IN_OFFICE]: 'H',
  [ASSIGNMENTS.THIRD_PARTY]: '3'
};

export const DIBS_OPTIONS_LABELS = {
  [DIBS_OPTIONS.DIBS_DESKTOP]: 'Desktop',
  [DIBS_OPTIONS.DIBS_ONLINE]: 'Online'
};

export const SCAN_SUBMISSION_LABELS = {
  [SCAN_SUBMISSION_METHODS.UPLOAD]: 'I am uploading STL files directly to this form.',
  [SCAN_SUBMISSION_METHODS.SCANNER]: 'I am sending scans directly from my intraoral scanner.'
};

const ARCH_LABELS = {
  [ARCHES.MAXILLARY]: 'Maxillary',
  [ARCHES.MANDIBULAR]: 'Mandibular',
  [ARCHES.BOTH]: 'Both'
};

export const EXPORT_LABELS = {
  [EXPORTS.TRAYS]: '3D Printed IDB Trays',
  [EXPORTS.GUIDES]: 'Guides',
  [EXPORTS.BRACKETS]: 'Brackets'
};

export const SCANNER_LABELS = {
  [SCANNERS.ITERO]: 'iTero',
  [SCANNERS.THREE_SHAPE]: '3Shape',
  [SCANNERS.THREE_M]: '3M',
  [SCANNERS.CARESTREAM]: 'Carestream',
  [SCANNERS.CEREC]: 'Cerec',
  [SCANNERS.MEDIT]: 'Medit',
  [SCANNERS.ALLIEDSTAR]: 'Alliedstar',
  [SCANNERS.OTHER]: 'Other'
};

export const ARCH_OPTIONS = createOptions(ARCH_LABELS);

export const EXPORT_OPTIONS = createOptions(EXPORT_LABELS);

export const SCANNER_OPTIONS = [
  ...createOptions(
    Object.fromEntries(
      Object.entries(SCANNER_LABELS).filter(([key]) => Number(key) !== SCANNERS.OTHER)
    )
  ),
  ...createOptions({ [SCANNERS.OTHER]: SCANNER_LABELS[SCANNERS.OTHER] })
];

export const REMOVED_SCANNERS = [SCANNERS.THREE_M];

export const OPTIONS = {
  [IDB_ATTRIBUTES.ARCH_TYPE]: ARCH_OPTIONS,
  [IDB_ATTRIBUTES.EXPORT_TYPE]: EXPORT_OPTIONS,
  [IDB_ATTRIBUTES.SCANNER]: SCANNER_OPTIONS
};

export const ATTRIBUTE_VALUE_LABELS = {
  [IDB_ATTRIBUTES.INITIAL_CASE_SETUP_ASSIGNMENT]: ASSIGNMENT_LABELS,
  [IDB_ATTRIBUTES.PRINT_ASSIGNMENT]: ASSIGNMENT_LABELS,
  [IDB_ATTRIBUTES.TRAY_DESIGN_ASSIGNMENT]: TRAY_DESIGN_ASSIGNMENT_LABELS,
  [IDB_ATTRIBUTES.INSERT_BRACKETS_ASSIGNMENT]: ASSIGNMENT_LABELS,
  [IDB_ATTRIBUTES.SCAN_SUBMISSION_METHOD]: SCAN_SUBMISSION_LABELS,
  [IDB_ATTRIBUTES.ARCH_TYPE]: ARCH_LABELS,
  [IDB_ATTRIBUTES.SCANNER]: SCANNER_LABELS,
  [IDB_ATTRIBUTES.EXPORT_TYPE]: EXPORT_LABELS,
  [IDB_ATTRIBUTES.ROOT_INTEGRATION_TYPE]: ROOT_INTEGRATION_TYPE_LABELS
};
